<div
    class="icon-container"
    [class.has-image]="settings && settings.img && settings.img.src"
>
    <div
        class="icon-image-container"
        *ngIf="settings && settings.img && settings.img.src"
    >
        <img
            class="icon-image"
            [src]="(settings.img && settings.img.src) ? settings.img.src : ''"
            [alt]="(settings.img && settings.img.alt) ? settings.img.alt : ''"
            [title]="(settings && settings.img && settings.img.title) ? settings.img.title : ''"
        >
    </div>

    <div class="icon-title-and-blurb-container">
        <span
            class="icon-title"
            *ngIf="settings.title"
        >
            {{settings.title}}
        </span>
        <span
            class="icon-blurb"
            *ngIf="settings.blurb"
            [class.alert]="settings.alert"
        >
            {{settings.blurb}}
        </span>
    </div>

</div>
